import styled from 'styled-components';

export const Percentage = styled.span.attrs(() => ({}))<{
  isPositive: boolean;
}>`
  border-radius: 2px;
  background: ${(props) => (props.isPositive ? 'var(--success-color)' : 'var(--error-color)')};
  padding: 2px 4px;
  font-size: 10px;
`;
